import axios from "axios";
import Config from "../../../config";

const v2_actionDetalhesLead = (leadId) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/${leadId}/detalhes`
    });
};

export default v2_actionDetalhesLead;
